import { TextField } from "formik-mui";

export const MultiLineFullWidthField = (props) => (
  <TextField fullWidth multiline rows={4} {...props} />
);
